
import { Routes, Route } from 'react-router-dom'
import { Layout } from 'frame'
import { ModuleRoutes as FbtSubmissionsRoutes } from 'features/fbt-submissions'
import { ModuleRoutes as FbtSummaryRoutes } from 'features/fbt-summary'

import useFbtNavigation from './navigation-config'
import { useEnabledFeatureToggleList } from 'features/settings'
import { Page404 } from 'frame/components'

const FBTRoutes = () => {
  const navigation = useFbtNavigation()
  const featureToggleList = useEnabledFeatureToggleList()

  const fbtFeatureToggle = featureToggleList.includes('FBT')

  if (!fbtFeatureToggle) {
    return (
      <Layout>
        <Page404 withoutNav />
      </Layout>
    )
  }

  return (
    <Layout accordionNavigation={navigation}>
      <Routes>
        <Route path="summary" element={<FbtSummaryRoutes />} />
        <Route path="submissions/*" element={<FbtSubmissionsRoutes />} />
        <Route path="" element={<FbtSubmissionsRoutes />} />
      </Routes>
    </Layout>
  )
}

export default FBTRoutes
